var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6562 5.625H22.5V2.34375H20.625V5.625H9.375V2.34375H7.5V5.625H2.34375C1.97092 5.62543 1.61349 5.77373 1.34986 6.03736C1.08623 6.30099 0.937934 6.65842 0.9375 7.03125V26.7188C0.937934 27.0916 1.08623 27.449 1.34986 27.7126C1.61349 27.9763 1.97092 28.1246 2.34375 28.125H27.6562C28.0291 28.1246 28.3865 27.9763 28.6501 27.7126C28.9138 27.449 29.0621 27.0916 29.0625 26.7188V7.03125C29.0621 6.65842 28.9138 6.30099 28.6501 6.03736C28.3865 5.77373 28.0291 5.62543 27.6562 5.625V5.625ZM27.1875 26.25H2.8125V7.5H7.5V9.84375H9.375V7.5H20.625V9.84375H22.5V7.5H27.1875V26.25Z",
    fill: "#226C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 13.125H8.4375V15H6.5625V13.125Z",
    fill: "#226C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 13.125H13.5938V15H11.7188V13.125Z",
    fill: "#226C55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 13.125H18.2812V15H16.4062V13.125Z",
    fill: "#226C55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 13.125H23.4375V15H21.5625V13.125Z",
    fill: "#226C55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 17.3438H8.4375V19.2188H6.5625V17.3438Z",
    fill: "#226C55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 17.3438H13.5938V19.2188H11.7188V17.3438Z",
    fill: "#226C55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 17.3438H18.2812V19.2188H16.4062V17.3438Z",
    fill: "#226C55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 17.3438H23.4375V19.2188H21.5625V17.3438Z",
    fill: "#226C55"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 21.5625H8.4375V23.4375H6.5625V21.5625Z",
    fill: "#226C55"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 21.5625H13.5938V23.4375H11.7188V21.5625Z",
    fill: "#226C55"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 21.5625H18.2812V23.4375H16.4062V21.5625Z",
    fill: "#226C55"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 21.5625H23.4375V23.4375H21.5625V21.5625Z",
    fill: "#226C55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.12cd1834.svg";
export { ForwardRef as ReactComponent };